import { Flex, Skeleton, Spacer } from "@chakra-ui/react";
import { HorizontallyBoundedContainer } from "src/components/Layout/HorizontallyBoundedContainer";

export const Loading = () => {
  return (
    <HorizontallyBoundedContainer>
      <Flex
        direction="column"
        gap="10"
        alignItems="center"
        marginY="10"
        marginX="4"
      >
        <Flex direction="row" gap="2" width="100%">
          <Skeleton width="200px" height="2rem" />
          <Spacer />
          <Skeleton width="100px" height="2rem" />
        </Flex>
        <Skeleton width="100%" height="10rem" />
        <Skeleton width="100%" height="10rem" />
        <Skeleton width="100%" height="10rem" />
      </Flex>
    </HorizontallyBoundedContainer>
  );
};
